import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserCategoryPage } from '@/features/users/pages/UserCategoryPage';

export const Route = createFileRoute('/_auth/users/agent')({
  beforeLoad: () => requirePermission(RBAC_PERMISSIONS.USER_AGENT_VIEW),
  component: () => (
    <ErrorBoundary moduleName="Agent Users">
      <Suspense fallback={<PageLoader />}>
        <UserCategoryPage category="agent" />
      </Suspense>
    </ErrorBoundary>
  ),
});
